import { useDrag } from "react-dnd";
import { ScrambleBlankContainer } from "./ScrambleBlank";

export default ({ blacklist = false, char, index, pin = false }: any) => {
  const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
    type: "LETTER",
    item: { char, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={dragPreview}
      className={pin ? "" : "l-" + index}
      style={{ opacity: char === " " ? 0.0 : isDragging ? 0.5 : 1 }}
    >
      {/* The drag ref marks this node as being the "pick-up" node */}
      <div role="Handle" ref={drag} data-char={char}>
        <ScrambleBlankContainer>{char}</ScrambleBlankContainer>
      </div>
    </div>
  );
};
